module.exports = __webpack_public_path__ + "static/img/wsd840.155d4bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wsd840.jpg
// module id = 1MzP
// module chunks = 0